export const passwordValidationPattern =
  /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{10,}$/;

/**
 * Printable ASCII special characters excluding space.
 * For optional checklist feedback only — not part of passwordValidationPattern.
 */
export const asciiSpecialCharacterPattern =
  /[!"#$%&'()*+,./:;<=>?@[\\\]^_`{|}~-]/;

/** True when the password contains at least one printable ASCII special (no space). */
export function hasAsciiSpecialCharacter(password: string): boolean {
  return asciiSpecialCharacterPattern.test(password);
}
